"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventorsGuild = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var InventorsGuild = (function (_super) {
    __extends(InventorsGuild, _super);
    function InventorsGuild() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.INVENTORS_GUILD,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 9,
            metadata: {
                cardNumber: '006',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action(undefined, function (eb) { return eb.empty().startAction.empty(); }).text('Action: Look at the top card and either buy it or discard it', Size_1.Size.SMALL, true);
                }),
            },
        }) || this;
    }
    InventorsGuild.prototype.play = function (_player) {
        return undefined;
    };
    InventorsGuild.prototype.canAct = function () {
        return true;
    };
    InventorsGuild.prototype.action = function (player) {
        return player.drawCardKeepSome(1, { paying: true });
    };
    return InventorsGuild;
}(Card_1.Card));
exports.InventorsGuild = InventorsGuild;
